export default __webpack_public_path__ + "static/media/test-image-square.6736056c.jpg";